/**
 * Browser messages for a failed dynamic import differ across engines. Keep
 * this check narrow: callers use it to distinguish an obsolete deployed chunk
 * from an ordinary action failure, and the recovery copy is different.
 */
const CHUNK_LOAD_ERROR_RE =
  /dynamically imported module|Importing a module script failed|Unable to preload CSS/i

export function isChunkLoadError(error: unknown): boolean {
  return error instanceof Error && CHUNK_LOAD_ERROR_RE.test(error.message)
}
